"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestedAccountName = exports.getFetchSuggestedAccountNameRequestStatus = exports.getSaveHubRequestStatus = exports.getFetchHubRequestStatus = exports.getStagedChangesCount = exports.getStagedChanges = exports.getHub = exports.getCurrentHubData = void 0;

var _immutable = require("immutable");

var _reselect = require("reselect");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var getHubState = function getHubState(state) {
  return state.hub;
};

var getCurrentHubData = (0, _reselect.createSelector)([getHubState], function (hubState) {
  return hubState.get('data');
});
exports.getCurrentHubData = getCurrentHubData;
var getHub = (0, _reselect.createSelector)([getHubState], function (hubState) {
  return hubState.get('data').merge(hubState.get('staged'));
});
exports.getHub = getHub;
var getStagedChanges = (0, _reselect.createSelector)([getHubState], function (hubState) {
  return hubState.get('staged').reduce(function (acc, val, key) {
    if (hubState.getIn(['data', key]) !== val) {
      return acc.set(key, val);
    }

    return acc;
  }, (0, _immutable.Map)());
});
exports.getStagedChanges = getStagedChanges;
var getStagedChangesCount = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.size;
});
exports.getStagedChangesCount = getStagedChangesCount;
var getFetchHubRequestStatus = (0, _getRequestStatus.default)(_actions.HubActionTypes.FETCH_HUB);
exports.getFetchHubRequestStatus = getFetchHubRequestStatus;
var getSaveHubRequestStatus = (0, _getRequestStatus.default)(_actions.HubActionTypes.UPDATE_HUB);
exports.getSaveHubRequestStatus = getSaveHubRequestStatus;
var getFetchSuggestedAccountNameRequestStatus = (0, _getRequestStatus.default)(_actions.HubActionTypes.FETCH_SUGGESTED_ACCOUNT_NAME);
exports.getFetchSuggestedAccountNameRequestStatus = getFetchSuggestedAccountNameRequestStatus;
var getSuggestedAccountNameData = (0, _reselect.createSelector)([getHubState], function (hubState) {
  return hubState.get('suggestedAccountName');
});
var getSuggestedAccountName = (0, _reselect.createSelector)([getSuggestedAccountNameData], function (suggestion) {
  return suggestion.get('accountName', '');
});
exports.getSuggestedAccountName = getSuggestedAccountName;